var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-footer",
    {
      staticClass: "bar font-weight-light",
      attrs: { app: "", title: "footer" },
    },
    [
      _c("span", { staticClass: "bar-visible--text" }, [
        _vm._v(
          " The MITRE Corporation © 2018-" +
            _vm._s(new Date().getFullYear()) +
            " "
        ),
      ]),
      _c("v-spacer"),
      _c(
        "v-btn",
        {
          staticClass: "text-decoration-none pr-4",
          attrs: {
            href: "https://github.com/mitre/heimdall2",
            target: "_blank",
            text: "",
            medium: "",
          },
        },
        [
          _c("v-icon", { attrs: { medium: "", color: "white" } }, [
            _vm._v("mdi-github"),
          ]),
        ],
        1
      ),
      _c(
        "v-btn",
        {
          attrs: {
            href: "https://www.netlify.com",
            target: "_blank",
            text: "",
            medium: "",
          },
        },
        [
          _c("img", {
            staticStyle: {
              width: "1.5rem",
              height: "1.5rem",
              "vertical-align": "middle",
            },
            attrs: {
              src: require("@/assets/netlify-light.svg"),
              alt: "Netlify.com",
            },
          }),
        ]
      ),
      _c(
        "v-btn",
        {
          staticClass: "pl-4",
          attrs: {
            href: _vm.repository + _vm.changelog,
            target: "_blank",
            text: "",
            medium: "",
            "no-padding": "",
          },
        },
        [
          _c("v-icon", { attrs: { medium: "" } }, [
            _vm._v("mdi-alpha-v-circle"),
          ]),
          _c(
            "span",
            {
              staticClass: "d-sm-inline text-center pl-1 text-decoration-none",
            },
            [_vm._v(_vm._s(_vm.version))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }